var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.582,
    height: 21.098,
    viewBox: "0 0 21.582 21.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "subscriptions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6020",
    "data-name": "Group 6020",
    transform: "translate(-700 -553.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5341",
    "data-name": "Group 5341",
    transform: "translate(8815.568 -7753.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M167.641,115.88h5.9a6.305,6.305,0,0,0,11-4.194,6.174,6.174,0,0,0-2.581-5.065v-5.065a4.681,4.681,0,0,0-4.678-4.678h-9.646a4.681,4.681,0,0,0-4.678,4.678V111.2a4.681,4.681,0,0,0,4.678,4.678Zm-3.065-14.323a3.084,3.084,0,0,1,3.065-3.065h9.646a3.084,3.084,0,0,1,3.065,3.065v4.194a6.7,6.7,0,0,0-2.129-.355,6.435,6.435,0,0,0-1.581.194h-9.549V107.2h6.71a6.537,6.537,0,0,0-1.194,1.613h-5.517v1.613h4.936a5.557,5.557,0,0,0-.129,1.258,6.165,6.165,0,0,0,.548,2.581h-4.839a3.084,3.084,0,0,1-3.065-3.065v-9.646Zm8.13,10.13a5.484,5.484,0,1,1,5.484,5.484A5.479,5.479,0,0,1,172.705,111.686Z",
    transform: "translate(-8278.531 8210.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M234.64,191.52h10.71v1.613H234.64Z",
    transform: "translate(-8346.079 8120.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M364.644,297.18a.4.4,0,0,0,.161-.774,2.988,2.988,0,0,1-1.774-3.839,3.043,3.043,0,0,1,1.548-1.678,3.128,3.128,0,0,1,2.291-.1,3.05,3.05,0,0,1,1.807,1.871l-.742-.032,1.1,2.161,1.323-2.032-.807-.032a3.829,3.829,0,0,0-2.387-2.678,3.787,3.787,0,0,0-2.645,7.1.193.193,0,0,0,.129.032Z",
    transform: "translate(-8466.147 8028.305)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.a5d46be8f862bc702757efd5faa61dec.svg";
export { ForwardRef as ReactComponent };